@if (segmentList()?.length) {
    <div
        class="bazis-segment__content"
        [ngClass]="{
            'bazis-segment__content_equal': isEqualParts(),
            'bazis-segment__content_scrollable': scrollable(),
        }"
    >
        @for (segment of segmentList(); track segment.id) {
            <bazis-segment-item
                [segmentItem]="segment"
                [hideByZeroCount]="hideByZeroCount()"
                [selectedSegmentItem]="selectedSegment()"
                (click)="selectSegment(segment.id)"
            >
                <ng-container
                    [ngTemplateOutlet]="segmentContent"
                    [ngTemplateOutletContext]="{
                        segment: segment,
                    }"
                ></ng-container>
            </bazis-segment-item>
        }
    </div>
}

<ng-template
    #segmentContent
    let-segment="segment"
>
    @if (segment.icon) {
        <bazis-icon [icon]="segment.icon"></bazis-icon>
    }
    @if (segment.title) {
        <span>
            {{ segment.title }}
        </span>
    }
    @if (segment.titleKey && !segment.type) {
        <span>
            {{ segment.titleKey | transloco: segment.titleParams }}
        </span>
    }

    @if (segment.type && segmentTemplate) {
        <ng-container
            [ngTemplateOutlet]="segmentTemplate"
            [ngTemplateOutletContext]="{ segment: segment }"
        ></ng-container>
    }
</ng-template>
